/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToMutation } from '../../mutators/add-meta';
import { addMetaToQuery } from '../../mutators/add-meta';
import type {
  CreateBackupRequest,
  CreateCloudBackupRequest,
  CreateCloudBackupResponse,
  DeleteCloudBackupResponse,
  DownloadCloudBackupResponse,
  DownloadSiteBackupDeprecatedParams,
  Error,
  FindSiteBackupDeprecatedParams,
  GetCloudBackupResponse,
  ListAutomatedBackupResponse,
  ListAutomatedSiteBackupsParams,
  ListBackupResponse,
  ListCloudBackupsResponse,
  ListSiteCloudBackupsParams,
  RecoveryPoint,
  RestoreAutomatedBackupFilesRequest,
  RestoreBackupRequest,
  RestoreCloudBackupRequest,
  SiteID,
  SuccessResponse,
  TaskIDResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * [Deprecated] Use /sites/{id}/cloud_backups instead.
 * @summary [Deprecated] Create a new backup for given site.
 */
export const createSiteBackupDeprecated = (
  id: SiteID,
  createBackupRequest: CreateBackupRequest,
  signal?: AbortSignal
) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/backup`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createBackupRequest,
    signal,
  });
};

export const getCreateSiteBackupDeprecatedMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteBackupDeprecated>>,
    TError,
    { id: SiteID; data: CreateBackupRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteBackupDeprecated>>,
  TError,
  { id: SiteID; data: CreateBackupRequest },
  TContext
> => {
  const mutationKey = ['createSiteBackupDeprecated'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteBackupDeprecated>>,
    { id: SiteID; data: CreateBackupRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteBackupDeprecated(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/backup` },
    {
      operationId: 'app.controllers.backups_controller.create_site_backup_deprecated',
      operationName: 'createSiteBackupDeprecated',
    }
  );

  return customOptions;
};

export type CreateSiteBackupDeprecatedMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteBackupDeprecated>>
>;
export type CreateSiteBackupDeprecatedMutationBody = CreateBackupRequest;
export type CreateSiteBackupDeprecatedMutationError = Error;

/**
 * @summary [Deprecated] Create a new backup for given site.
 */
export const useCreateSiteBackupDeprecated = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteBackupDeprecated>>,
      TError,
      { id: SiteID; data: CreateBackupRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteBackupDeprecated>>,
  TError,
  { id: SiteID; data: CreateBackupRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteBackupDeprecatedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * [Deprecated] Use /sites/{id}/cloud_backups instead.
 * @summary [Deprecated] Get a list of backups for site
 */
export const findSiteBackupDeprecated = (
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<ListBackupResponse>({
    url: `/v1/sites/${id}/backup`,
    method: 'GET',
    params,
    signal,
  });
};

export const getFindSiteBackupDeprecatedQueryKey = (
  id?: SiteID,
  params?: FindSiteBackupDeprecatedParams
) => {
  return [`/v1/sites/${id}/backup`, ...(params ? [params] : [])] as const;
};

export const getFindSiteBackupDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteBackupDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteBackupDeprecated>>> = ({
    signal,
  }) => findSiteBackupDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/backup`,
      operationId: 'app.controllers.backups_controller.find_site_backup_deprecated',
      operationName: 'findSiteBackupDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteBackupDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteBackupDeprecated>>
>;
export type FindSiteBackupDeprecatedQueryError = Error;

export function useFindSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | FindSiteBackupDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
          TError,
          Awaited<ReturnType<typeof findSiteBackupDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
          TError,
          Awaited<ReturnType<typeof findSiteBackupDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Get a list of backups for site
 */

export function useFindSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteBackupDeprecatedQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteBackupDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteBackupDeprecatedQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteBackupDeprecated>>> = ({
    signal,
  }) => findSiteBackupDeprecated(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/backup`,
      operationId: 'app.controllers.backups_controller.find_site_backup_deprecated',
      operationName: 'findSiteBackupDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteBackupDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteBackupDeprecated>>
>;
export type FindSiteBackupDeprecatedSuspenseQueryError = Error;

export function useFindSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | FindSiteBackupDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Get a list of backups for site
 */

export function useFindSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof findSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  params?: FindSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteBackupDeprecatedSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Returns paginated recovery points created by automatic backups for the site. Each entry includes a recovery point ID, timestamp, and status.
 * @summary List Automated Backups
 */
export const listAutomatedSiteBackups = (
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListAutomatedBackupResponse>({
    url: `/v1/sites/${id}/backup/automated`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListAutomatedSiteBackupsQueryKey = (
  id?: SiteID,
  params?: ListAutomatedSiteBackupsParams
) => {
  return [`/v1/sites/${id}/backup/automated`, ...(params ? [params] : [])] as const;
};

export const getListAutomatedSiteBackupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAutomatedSiteBackupsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAutomatedSiteBackups>>> = ({
    signal,
  }) => listAutomatedSiteBackups(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/backup/automated`,
      operationId: 'app.controllers.backups_controller.list_automated_site_backups',
      operationName: 'listAutomatedSiteBackups',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomatedSiteBackupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomatedSiteBackups>>
>;
export type ListAutomatedSiteBackupsQueryError = Error;

export function useListAutomatedSiteBackups<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListAutomatedSiteBackupsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
          TError,
          Awaited<ReturnType<typeof listAutomatedSiteBackups>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAutomatedSiteBackups<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
          TError,
          Awaited<ReturnType<typeof listAutomatedSiteBackups>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAutomatedSiteBackups<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Automated Backups
 */

export function useListAutomatedSiteBackups<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAutomatedSiteBackupsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListAutomatedSiteBackupsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListAutomatedSiteBackupsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listAutomatedSiteBackups>>> = ({
    signal,
  }) => listAutomatedSiteBackups(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/backup/automated`,
      operationId: 'app.controllers.backups_controller.list_automated_site_backups',
      operationName: 'listAutomatedSiteBackups',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListAutomatedSiteBackupsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listAutomatedSiteBackups>>
>;
export type ListAutomatedSiteBackupsSuspenseQueryError = Error;

export function useListAutomatedSiteBackupsSuspense<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListAutomatedSiteBackupsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAutomatedSiteBackupsSuspense<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListAutomatedSiteBackupsSuspense<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Automated Backups
 */

export function useListAutomatedSiteBackupsSuspense<
  TData = Awaited<ReturnType<typeof listAutomatedSiteBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListAutomatedSiteBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listAutomatedSiteBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListAutomatedSiteBackupsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Queues a background task to restore both files and database from a scheduled recovery point. Replaces the site's current files and database with the snapshot. Returns a task ID.
 * @summary Restore a full Automated Backup
 */
export const restoreAutomatedSiteBackup = (
  id: SiteID,
  restoreId: RecoveryPoint,
  signal?: AbortSignal
) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/backup/automated/${restoreId}/restore`,
    method: 'POST',
    signal,
  });
};

export const getRestoreAutomatedSiteBackupMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAutomatedSiteBackup>>,
    TError,
    { id: SiteID; restoreId: RecoveryPoint },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackup>>,
  TError,
  { id: SiteID; restoreId: RecoveryPoint },
  TContext
> => {
  const mutationKey = ['restoreAutomatedSiteBackup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAutomatedSiteBackup>>,
    { id: SiteID; restoreId: RecoveryPoint }
  > = props => {
    const { id, restoreId } = props ?? {};

    return restoreAutomatedSiteBackup(id, restoreId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/backup/automated/{restoreId}/restore` },
    {
      operationId: 'app.controllers.backups_controller.restore_automated_site_backup',
      operationName: 'restoreAutomatedSiteBackup',
    }
  );

  return customOptions;
};

export type RestoreAutomatedSiteBackupMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackup>>
>;

export type RestoreAutomatedSiteBackupMutationError = Error;

/**
 * @summary Restore a full Automated Backup
 */
export const useRestoreAutomatedSiteBackup = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreAutomatedSiteBackup>>,
      TError,
      { id: SiteID; restoreId: RecoveryPoint },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackup>>,
  TError,
  { id: SiteID; restoreId: RecoveryPoint },
  TContext
> => {
  const mutationOptions = getRestoreAutomatedSiteBackupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Queues a background task to restore the database from a scheduled recovery point without changing site files. Useful when fixing database issues while keeping current files. Returns a task ID.
 * @summary Restore only the database from an Automated Backup
 */
export const restoreAutomatedSiteBackupDatabase = (
  id: SiteID,
  restoreId: RecoveryPoint,
  signal?: AbortSignal
) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/backup/automated/${restoreId}/restore/database`,
    method: 'POST',
    signal,
  });
};

export const getRestoreAutomatedSiteBackupDatabaseMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAutomatedSiteBackupDatabase>>,
    TError,
    { id: SiteID; restoreId: RecoveryPoint },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackupDatabase>>,
  TError,
  { id: SiteID; restoreId: RecoveryPoint },
  TContext
> => {
  const mutationKey = ['restoreAutomatedSiteBackupDatabase'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAutomatedSiteBackupDatabase>>,
    { id: SiteID; restoreId: RecoveryPoint }
  > = props => {
    const { id, restoreId } = props ?? {};

    return restoreAutomatedSiteBackupDatabase(id, restoreId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/backup/automated/{restoreId}/restore/database` },
    {
      operationId: 'app.controllers.backups_controller.restore_automated_site_backup_database',
      operationName: 'restoreAutomatedSiteBackupDatabase',
    }
  );

  return customOptions;
};

export type RestoreAutomatedSiteBackupDatabaseMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackupDatabase>>
>;

export type RestoreAutomatedSiteBackupDatabaseMutationError = Error;

/**
 * @summary Restore only the database from an Automated Backup
 */
export const useRestoreAutomatedSiteBackupDatabase = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreAutomatedSiteBackupDatabase>>,
      TError,
      { id: SiteID; restoreId: RecoveryPoint },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackupDatabase>>,
  TError,
  { id: SiteID; restoreId: RecoveryPoint },
  TContext
> => {
  const mutationOptions = getRestoreAutomatedSiteBackupDatabaseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Queues a background task to restore site files from a scheduled recovery point. Choose a full restore of all files or a partial restore of specific paths. Returns a task ID.
 * @summary Restore files from an Automated Backup
 */
export const restoreAutomatedSiteBackupFiles = (
  id: SiteID,
  restoreId: RecoveryPoint,
  restoreAutomatedBackupFilesRequest: RestoreAutomatedBackupFilesRequest,
  signal?: AbortSignal
) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/backup/automated/${restoreId}/restore/files`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: restoreAutomatedBackupFilesRequest,
    signal,
  });
};

export const getRestoreAutomatedSiteBackupFilesMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreAutomatedSiteBackupFiles>>,
    TError,
    { id: SiteID; restoreId: RecoveryPoint; data: RestoreAutomatedBackupFilesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackupFiles>>,
  TError,
  { id: SiteID; restoreId: RecoveryPoint; data: RestoreAutomatedBackupFilesRequest },
  TContext
> => {
  const mutationKey = ['restoreAutomatedSiteBackupFiles'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreAutomatedSiteBackupFiles>>,
    { id: SiteID; restoreId: RecoveryPoint; data: RestoreAutomatedBackupFilesRequest }
  > = props => {
    const { id, restoreId, data } = props ?? {};

    return restoreAutomatedSiteBackupFiles(id, restoreId, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/backup/automated/{restoreId}/restore/files` },
    {
      operationId: 'app.controllers.backups_controller.restore_automated_site_backup_files',
      operationName: 'restoreAutomatedSiteBackupFiles',
    }
  );

  return customOptions;
};

export type RestoreAutomatedSiteBackupFilesMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackupFiles>>
>;
export type RestoreAutomatedSiteBackupFilesMutationBody = RestoreAutomatedBackupFilesRequest;
export type RestoreAutomatedSiteBackupFilesMutationError = Error;

/**
 * @summary Restore files from an Automated Backup
 */
export const useRestoreAutomatedSiteBackupFiles = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreAutomatedSiteBackupFiles>>,
      TError,
      { id: SiteID; restoreId: RecoveryPoint; data: RestoreAutomatedBackupFilesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreAutomatedSiteBackupFiles>>,
  TError,
  { id: SiteID; restoreId: RecoveryPoint; data: RestoreAutomatedBackupFilesRequest },
  TContext
> => {
  const mutationOptions = getRestoreAutomatedSiteBackupFilesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * [Deprecated] Use /sites/{id}/cloud_backups/{backup_id}/download instead.
 * @summary [Deprecated] Download given backup for site
 */
export const downloadSiteBackupDeprecated = (
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  signal?: AbortSignal
) => {
  return customFetch<Blob>({
    url: `/v1/sites/${id}/backup/${backupId}`,
    method: 'GET',
    params,
    responseType: 'blob',
    signal,
  });
};

export const getDownloadSiteBackupDeprecatedQueryKey = (
  id?: SiteID,
  backupId?: number,
  params?: DownloadSiteBackupDeprecatedParams
) => {
  return [`/v1/sites/${id}/backup/${backupId}`, ...(params ? [params] : [])] as const;
};

export const getDownloadSiteBackupDeprecatedQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadSiteBackupDeprecatedQueryKey(id, backupId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>> = ({
    signal,
  }) => downloadSiteBackupDeprecated(id, backupId, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, backupId, params },
    {
      url: `/v1/sites/${id}/backup/${backupId}`,
      operationId: 'app.controllers.backups_controller.download_site_backup_deprecated',
      operationName: 'downloadSiteBackupDeprecated',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSiteBackupDeprecatedQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>
>;
export type DownloadSiteBackupDeprecatedQueryError = Error;

export function useDownloadSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
          TError,
          Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
          TError,
          Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Download given backup for site
 */

export function useDownloadSiteBackupDeprecated<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadSiteBackupDeprecatedQueryOptions(id, backupId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDownloadSiteBackupDeprecatedSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
        TError,
        TData
      >
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getDownloadSiteBackupDeprecatedQueryKey(id, backupId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>> = ({
    signal,
  }) => downloadSiteBackupDeprecated(id, backupId, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, backupId, params },
    {
      url: `/v1/sites/${id}/backup/${backupId}`,
      operationId: 'app.controllers.backups_controller.download_site_backup_deprecated',
      operationName: 'downloadSiteBackupDeprecated',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSiteBackupDeprecatedSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>
>;
export type DownloadSiteBackupDeprecatedSuspenseQueryError = Error;

export function useDownloadSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary [Deprecated] Download given backup for site
 */

export function useDownloadSiteBackupDeprecatedSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
  TError = Error,
>(
  id: SiteID,
  backupId: number,
  params: DownloadSiteBackupDeprecatedParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof downloadSiteBackupDeprecated>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadSiteBackupDeprecatedSuspenseQueryOptions(
    id,
    backupId,
    params,
    options
  );

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * [Deprecated] Use /sites/{id}/cloud_backups/{backup_id} instead.
 * @summary [Deprecated] Delete given backup for site from the system.
 */
export const deleteSiteBackupDeprecated = (id: SiteID, backupId: number) => {
  return customFetch<SuccessResponse>({
    url: `/v1/sites/${id}/backup/${backupId}`,
    method: 'DELETE',
  });
};

export const getDeleteSiteBackupDeprecatedMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteBackupDeprecated>>,
    TError,
    { id: SiteID; backupId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteBackupDeprecated>>,
  TError,
  { id: SiteID; backupId: number },
  TContext
> => {
  const mutationKey = ['deleteSiteBackupDeprecated'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteBackupDeprecated>>,
    { id: SiteID; backupId: number }
  > = props => {
    const { id, backupId } = props ?? {};

    return deleteSiteBackupDeprecated(id, backupId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/backup/{backupId}` },
    {
      operationId: 'app.controllers.backups_controller.delete_site_backup_deprecated',
      operationName: 'deleteSiteBackupDeprecated',
    }
  );

  return customOptions;
};

export type DeleteSiteBackupDeprecatedMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteBackupDeprecated>>
>;

export type DeleteSiteBackupDeprecatedMutationError = Error;

/**
 * @summary [Deprecated] Delete given backup for site from the system.
 */
export const useDeleteSiteBackupDeprecated = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteBackupDeprecated>>,
      TError,
      { id: SiteID; backupId: number },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteBackupDeprecated>>,
  TError,
  { id: SiteID; backupId: number },
  TContext
> => {
  const mutationOptions = getDeleteSiteBackupDeprecatedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * [Deprecated] Use /sites/{id}/cloud_backups/{backup_id}/restore instead.
 * @summary [Deprecated] Restore a backup for given site (via background task)
 */
export const restoreSiteBackupDeprecated = (
  id: SiteID,
  backupId: number,
  restoreBackupRequest: RestoreBackupRequest,
  signal?: AbortSignal
) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/backup/${backupId}/restore`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: restoreBackupRequest,
    signal,
  });
};

export const getRestoreSiteBackupDeprecatedMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreSiteBackupDeprecated>>,
    TError,
    { id: SiteID; backupId: number; data: RestoreBackupRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreSiteBackupDeprecated>>,
  TError,
  { id: SiteID; backupId: number; data: RestoreBackupRequest },
  TContext
> => {
  const mutationKey = ['restoreSiteBackupDeprecated'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreSiteBackupDeprecated>>,
    { id: SiteID; backupId: number; data: RestoreBackupRequest }
  > = props => {
    const { id, backupId, data } = props ?? {};

    return restoreSiteBackupDeprecated(id, backupId, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/backup/{backupId}/restore` },
    {
      operationId: 'app.controllers.backups_controller.restore_site_backup_deprecated',
      operationName: 'restoreSiteBackupDeprecated',
    }
  );

  return customOptions;
};

export type RestoreSiteBackupDeprecatedMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreSiteBackupDeprecated>>
>;
export type RestoreSiteBackupDeprecatedMutationBody = RestoreBackupRequest;
export type RestoreSiteBackupDeprecatedMutationError = Error;

/**
 * @summary [Deprecated] Restore a backup for given site (via background task)
 */
export const useRestoreSiteBackupDeprecated = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreSiteBackupDeprecated>>,
      TError,
      { id: SiteID; backupId: number; data: RestoreBackupRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreSiteBackupDeprecated>>,
  TError,
  { id: SiteID; backupId: number; data: RestoreBackupRequest },
  TContext
> => {
  const mutationOptions = getRestoreSiteBackupDeprecatedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns paginated backups stored in remote storage, including label, size, status, whether files and database are included, WordPress metadata, and zip filename.
 * @summary List Cloud Backups
 */
export const listSiteCloudBackups = (
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  signal?: AbortSignal
) => {
  return customFetch<ListCloudBackupsResponse>({
    url: `/v1/sites/${id}/cloud_backups`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteCloudBackupsQueryKey = (
  id?: SiteID,
  params?: ListSiteCloudBackupsParams
) => {
  return [`/v1/sites/${id}/cloud_backups`, ...(params ? [params] : [])] as const;
};

export const getListSiteCloudBackupsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteCloudBackupsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteCloudBackups>>> = ({ signal }) =>
    listSiteCloudBackups(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/cloud_backups`,
      operationId: 'app.controllers.cloud_backups_controller.list_site_cloud_backups',
      operationName: 'listSiteCloudBackups',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteCloudBackups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteCloudBackupsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteCloudBackups>>
>;
export type ListSiteCloudBackupsQueryError = Error;

export function useListSiteCloudBackups<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteCloudBackupsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteCloudBackups>>,
          TError,
          Awaited<ReturnType<typeof listSiteCloudBackups>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteCloudBackups<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteCloudBackups>>,
          TError,
          Awaited<ReturnType<typeof listSiteCloudBackups>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteCloudBackups<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Cloud Backups
 */

export function useListSiteCloudBackups<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteCloudBackupsQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteCloudBackupsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteCloudBackupsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteCloudBackups>>> = ({ signal }) =>
    listSiteCloudBackups(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/cloud_backups`,
      operationId: 'app.controllers.cloud_backups_controller.list_site_cloud_backups',
      operationName: 'listSiteCloudBackups',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteCloudBackups>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteCloudBackupsSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteCloudBackups>>
>;
export type ListSiteCloudBackupsSuspenseQueryError = Error;

export function useListSiteCloudBackupsSuspense<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteCloudBackupsParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteCloudBackupsSuspense<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteCloudBackupsSuspense<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Cloud Backups
 */

export function useListSiteCloudBackupsSuspense<
  TData = Awaited<ReturnType<typeof listSiteCloudBackups>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteCloudBackupsParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteCloudBackups>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteCloudBackupsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Queues a background task to back up site files and/or the database to remote storage with a custom label. Optionally exclude specific paths. Staging sites back up only the staging environment. Returns backup ID and task ID.
 * @summary Create a Cloud Backup
 */
export const createSiteCloudBackup = (
  id: SiteID,
  createCloudBackupRequest: CreateCloudBackupRequest,
  signal?: AbortSignal
) => {
  return customFetch<CreateCloudBackupResponse>({
    url: `/v1/sites/${id}/cloud_backups`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: createCloudBackupRequest,
    signal,
  });
};

export const getCreateSiteCloudBackupMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createSiteCloudBackup>>,
    TError,
    { id: SiteID; data: CreateCloudBackupRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createSiteCloudBackup>>,
  TError,
  { id: SiteID; data: CreateCloudBackupRequest },
  TContext
> => {
  const mutationKey = ['createSiteCloudBackup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createSiteCloudBackup>>,
    { id: SiteID; data: CreateCloudBackupRequest }
  > = props => {
    const { id, data } = props ?? {};

    return createSiteCloudBackup(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/cloud_backups` },
    {
      operationId: 'app.controllers.cloud_backups_controller.create_site_cloud_backup',
      operationName: 'createSiteCloudBackup',
    }
  );

  return customOptions;
};

export type CreateSiteCloudBackupMutationResult = NonNullable<
  Awaited<ReturnType<typeof createSiteCloudBackup>>
>;
export type CreateSiteCloudBackupMutationBody = CreateCloudBackupRequest;
export type CreateSiteCloudBackupMutationError = Error;

/**
 * @summary Create a Cloud Backup
 */
export const useCreateSiteCloudBackup = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createSiteCloudBackup>>,
      TError,
      { id: SiteID; data: CreateCloudBackupRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createSiteCloudBackup>>,
  TError,
  { id: SiteID; data: CreateCloudBackupRequest },
  TContext
> => {
  const mutationOptions = getCreateSiteCloudBackupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns metadata for one stored backup: label, size, status, included components, creation time, associated task ID, WordPress version info, and zip filename.
 * @summary Get details of a Cloud Backup
 */
export const findSiteCloudBackup = (id: SiteID, backupId: string, signal?: AbortSignal) => {
  return customFetch<GetCloudBackupResponse>({
    url: `/v1/sites/${id}/cloud_backups/${backupId}`,
    method: 'GET',
    signal,
  });
};

export const getFindSiteCloudBackupQueryKey = (id?: SiteID, backupId?: string) => {
  return [`/v1/sites/${id}/cloud_backups/${backupId}`] as const;
};

export const getFindSiteCloudBackupQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteCloudBackupQueryKey(id, backupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteCloudBackup>>> = ({ signal }) =>
    findSiteCloudBackup(id, backupId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, backupId },
    {
      url: `/v1/sites/${id}/cloud_backups/${backupId}`,
      operationId: 'app.controllers.cloud_backups_controller.find_site_cloud_backup',
      operationName: 'findSiteCloudBackup',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof findSiteCloudBackup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteCloudBackupQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteCloudBackup>>
>;
export type FindSiteCloudBackupQueryError = Error;

export function useFindSiteCloudBackup<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteCloudBackup>>,
          TError,
          Awaited<ReturnType<typeof findSiteCloudBackup>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCloudBackup<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof findSiteCloudBackup>>,
          TError,
          Awaited<ReturnType<typeof findSiteCloudBackup>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCloudBackup<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get details of a Cloud Backup
 */

export function useFindSiteCloudBackup<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteCloudBackupQueryOptions(id, backupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getFindSiteCloudBackupSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFindSiteCloudBackupQueryKey(id, backupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findSiteCloudBackup>>> = ({ signal }) =>
    findSiteCloudBackup(id, backupId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, backupId },
    {
      url: `/v1/sites/${id}/cloud_backups/${backupId}`,
      operationId: 'app.controllers.cloud_backups_controller.find_site_cloud_backup',
      operationName: 'findSiteCloudBackup',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof findSiteCloudBackup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FindSiteCloudBackupSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof findSiteCloudBackup>>
>;
export type FindSiteCloudBackupSuspenseQueryError = Error;

export function useFindSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFindSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get details of a Cloud Backup
 */

export function useFindSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof findSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof findSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getFindSiteCloudBackupSuspenseQueryOptions(id, backupId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Removes the backup from remote storage permanently. The backup cannot be restored or downloaded afterward.
 * @summary Permanently delete a Cloud Backup
 */
export const deleteSiteCloudBackup = (id: SiteID, backupId: string) => {
  return customFetch<DeleteCloudBackupResponse>({
    url: `/v1/sites/${id}/cloud_backups/${backupId}`,
    method: 'DELETE',
  });
};

export const getDeleteSiteCloudBackupMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteCloudBackup>>,
    TError,
    { id: SiteID; backupId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteCloudBackup>>,
  TError,
  { id: SiteID; backupId: string },
  TContext
> => {
  const mutationKey = ['deleteSiteCloudBackup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteCloudBackup>>,
    { id: SiteID; backupId: string }
  > = props => {
    const { id, backupId } = props ?? {};

    return deleteSiteCloudBackup(id, backupId);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/cloud_backups/{backupId}` },
    {
      operationId: 'app.controllers.cloud_backups_controller.delete_site_cloud_backup',
      operationName: 'deleteSiteCloudBackup',
    }
  );

  return customOptions;
};

export type DeleteSiteCloudBackupMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteCloudBackup>>
>;

export type DeleteSiteCloudBackupMutationError = Error;

/**
 * @summary Permanently delete a Cloud Backup
 */
export const useDeleteSiteCloudBackup = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteCloudBackup>>,
      TError,
      { id: SiteID; backupId: string },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteCloudBackup>>,
  TError,
  { id: SiteID; backupId: string },
  TContext
> => {
  const mutationOptions = getDeleteSiteCloudBackupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns a time-limited URL to download the backup zip file. Use the link promptly; it expires after a short period.
 * @summary Get a temporary download URL for a Cloud Backup
 */
export const downloadSiteCloudBackup = (id: SiteID, backupId: string, signal?: AbortSignal) => {
  return customFetch<DownloadCloudBackupResponse>({
    url: `/v1/sites/${id}/cloud_backups/${backupId}/download`,
    method: 'GET',
    signal,
  });
};

export const getDownloadSiteCloudBackupQueryKey = (id?: SiteID, backupId?: string) => {
  return [`/v1/sites/${id}/cloud_backups/${backupId}/download`] as const;
};

export const getDownloadSiteCloudBackupQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadSiteCloudBackupQueryKey(id, backupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSiteCloudBackup>>> = ({
    signal,
  }) => downloadSiteCloudBackup(id, backupId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, backupId },
    {
      url: `/v1/sites/${id}/cloud_backups/${backupId}/download`,
      operationId: 'app.controllers.cloud_backups_controller.download_site_cloud_backup',
      operationName: 'downloadSiteCloudBackup',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSiteCloudBackupQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSiteCloudBackup>>
>;
export type DownloadSiteCloudBackupQueryError = Error;

export function useDownloadSiteCloudBackup<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
          TError,
          Awaited<ReturnType<typeof downloadSiteCloudBackup>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteCloudBackup<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
          TError,
          Awaited<ReturnType<typeof downloadSiteCloudBackup>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteCloudBackup<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a temporary download URL for a Cloud Backup
 */

export function useDownloadSiteCloudBackup<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadSiteCloudBackupQueryOptions(id, backupId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getDownloadSiteCloudBackupSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDownloadSiteCloudBackupQueryKey(id, backupId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof downloadSiteCloudBackup>>> = ({
    signal,
  }) => downloadSiteCloudBackup(id, backupId, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, backupId },
    {
      url: `/v1/sites/${id}/cloud_backups/${backupId}/download`,
      operationId: 'app.controllers.cloud_backups_controller.download_site_cloud_backup',
      operationName: 'downloadSiteCloudBackup',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DownloadSiteCloudBackupSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadSiteCloudBackup>>
>;
export type DownloadSiteCloudBackupSuspenseQueryError = Error;

export function useDownloadSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDownloadSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a temporary download URL for a Cloud Backup
 */

export function useDownloadSiteCloudBackupSuspense<
  TData = Awaited<ReturnType<typeof downloadSiteCloudBackup>>,
  TError = Error,
>(
  id: SiteID,
  backupId: string,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof downloadSiteCloudBackup>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getDownloadSiteCloudBackupSuspenseQueryOptions(id, backupId, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Queues a background task to restore files and/or the database from a stored backup onto the site. Optionally limit file restore to specific paths. Overwrites selected components on the target site. Returns a task ID.
 * @summary Restore a Cloud Backup to the site
 */
export const restoreSiteCloudBackup = (
  id: SiteID,
  backupId: string,
  restoreCloudBackupRequest: RestoreCloudBackupRequest,
  signal?: AbortSignal
) => {
  return customFetch<TaskIDResponse>({
    url: `/v1/sites/${id}/cloud_backups/${backupId}/restore`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: restoreCloudBackupRequest,
    signal,
  });
};

export const getRestoreSiteCloudBackupMutationOptions = <
  TError = Error,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof restoreSiteCloudBackup>>,
    TError,
    { id: SiteID; backupId: string; data: RestoreCloudBackupRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof restoreSiteCloudBackup>>,
  TError,
  { id: SiteID; backupId: string; data: RestoreCloudBackupRequest },
  TContext
> => {
  const mutationKey = ['restoreSiteCloudBackup'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof restoreSiteCloudBackup>>,
    { id: SiteID; backupId: string; data: RestoreCloudBackupRequest }
  > = props => {
    const { id, backupId, data } = props ?? {};

    return restoreSiteCloudBackup(id, backupId, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/cloud_backups/{backupId}/restore` },
    {
      operationId: 'app.controllers.cloud_backups_controller.restore_site_cloud_backup',
      operationName: 'restoreSiteCloudBackup',
    }
  );

  return customOptions;
};

export type RestoreSiteCloudBackupMutationResult = NonNullable<
  Awaited<ReturnType<typeof restoreSiteCloudBackup>>
>;
export type RestoreSiteCloudBackupMutationBody = RestoreCloudBackupRequest;
export type RestoreSiteCloudBackupMutationError = Error;

/**
 * @summary Restore a Cloud Backup to the site
 */
export const useRestoreSiteCloudBackup = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof restoreSiteCloudBackup>>,
      TError,
      { id: SiteID; backupId: string; data: RestoreCloudBackupRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof restoreSiteCloudBackup>>,
  TError,
  { id: SiteID; backupId: string; data: RestoreCloudBackupRequest },
  TContext
> => {
  const mutationOptions = getRestoreSiteCloudBackupMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
